import styled from 'styled-components';

export const CountryCodeWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-top: 1px;
`;

export const FlagWrapper = styled.div`
	margin-right: ${({ theme }) => theme.spacings.xxsmall};
	margin-bottom: 1px;
`;

export const SkeletonWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: ${({ theme }) => theme.colors.backgrounds.main.input};
	${({ theme }) => theme.border.radius.medium};
	min-height: ${({ theme }) => theme.sizing.xlarge};
	height: 56px;
	width: 80px;
	padding: 0 ${({ theme }) => theme.spacings.xsmall};
	border: ${({ theme }) => theme.border.width.medium} solid transparent;
`;
